import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  TextField,
  Button,
} from "@mui/material";

import { db } from "../../../config/firebase";
import { COLLECTION } from "../../../data/constant";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";

const AdminResolveDisputeModal = ({ open, onClose, transaction, onResolved }) => {
  const [disputes, setDisputes] = useState([]);
  const [resolutionInputs, setResolutionInputs] = useState({});

  useEffect(() => {
    if (!transaction) return;

    const load = async () => {
      try {
        const q = query(
          collection(db, COLLECTION.TRANSACTION_DISPUTES),
          where(
            "transactionID",
            "==",
            (transaction.transactionid || transaction.id).trim()
          )
        );

        const snapshot = await getDocs(q);
        const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));

        // ⭐ Sort: Resolved first, then Active at bottom
        const sorted = [
          ...list.filter((d) => d.status === "resolved"),
          ...list.filter((d) => d.status === "active"),
        ];

        setDisputes(sorted);
      } catch (err) {
        console.error("Error loading disputes:", err);
      }
    };

    load();
  }, [transaction]);

  const handleSubmitResolution = async (disputeId) => {
    const text = resolutionInputs[disputeId] || "";

    if (!text.trim()) return;

    try {
      await updateDoc(doc(db, COLLECTION.TRANSACTION_DISPUTES, disputeId), {
        status: "resolved",
        resolutionDescription: text,
      });

      onResolved();
      onClose();
    } catch (err) {
      console.error("Error updating dispute:", err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle  style={{
            marginTop: 20,
            marginLeft: "180px",
            fontFamily: "montserrat",
          }}
          >Resolve Disputes</DialogTitle>

      <DialogContent
        style={{
          maxHeight: "70vh",
          overflowY: "auto",
          paddingRight: "10px",
                      fontFamily: "montserrat",

        }}
      >
        {disputes.length === 0 ? (
          <Typography>No disputes found for this transaction.</Typography>
        ) : (
          disputes.map((d) => (
            <div key={d.id} style={{ marginBottom: 25 }}>
              {/* Issue */}
              <Typography style={{   fontFamily: "montserrat"}}>
                <strong>Issue:</strong> {d.issueDescription}
              </Typography>

              {/* Status */}
              <Typography style={{   fontFamily: "montserrat"}}>
                <strong>Status:</strong>{" "}
                {d.status === "active" ? (
                  <span style={{ color: "red" }}>Active</span>
                ) : (
                  <span style={{ color: "green" }}>Resolved</span>
                )}
              </Typography>

              {/* Resolved dispute response */}
              {d.status === "resolved" && d.resolutionDescription && (
                <Typography style={{   fontFamily: "montserrat"}}>
                  <strong>Admin Response:</strong> {d.resolutionDescription}
                </Typography>
              )}

              {/* ACTIVE dispute → show editor at the bottom */}
              {d.status === "active" && (
                <>
                  <TextField
                    fullWidth
                    label="Enter Resolution"
                    multiline
                    rows={2}
                    value={resolutionInputs[d.id] || ""}
                    onChange={(e) =>
                      setResolutionInputs({
                        ...resolutionInputs,
                        [d.id]: e.target.value,
                      })
                    }
                    style={{ marginTop: 15 }}
                  />

                  <Button
                    variant="contained"
                    onClick={() => handleSubmitResolution(d.id)}
                    style={{
            backgroundColor: "black",
            color: "white",
            marginTop: 20,
            marginLeft: "160px",
            fontFamily: "montserrat",
          }}
                  >
                    Submit Resolution
                  </Button>
                </>
              )}

              {/* Timestamp */}
              <Typography style={{ fontSize: 12, opacity: 0.7, marginTop: 10 }}>
                {new Date(d.createdAt).toLocaleString()}
              </Typography>

              <hr style={{ marginTop: 10 }} />
            </div>
          ))
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AdminResolveDisputeModal;
